<template>
  <v-row>

    <v-col
      v-for="(product, index) in assistance.products"
      :key="index"
      cols="10"
      sm="10"
      md="8"
      lg="8"
      offset-sm="1"
      offset-md="2"
      offset-lg="2"
      offset="1"
    >
      <v-card class="ghd-border-black">
        <div class="align-start ghd-ITCAvant text-black ml-5 pt-4 text-medium">
          {{ product.prodotto.nome }}
          <v-chip
            v-if="product.need_scenario"
            class="v-chip-light-bg warning--text"
            color="warning"
            small
          >
            Seleziona un'opzione
          </v-chip>
        </div>

        <v-card-subtitle>
          Data code: {{ product.prodotto.codice_ean }}{{ product.prodotto.seriale }}
        </v-card-subtitle>

        <v-card-text>
          <div v-if="product.scenario && scenarioIsAConfirmedScenario(product.scenario.sigla)">
            <div class="ghd-ITCAvant text-black pt-4 text-large">
              {{ getLabelForConfirmedScenario(product.scenario.sigla) }}
            </div>
            <div v-if="(product.status_price && product.status_price !== 'undefined') || product.final_price_scenario">
              <div>
                <span class="text-medium text-black">Prezzo finale: </span> <span class="ghd-ITCAvant text-black pt-4 text-large">{{ product.final_price_scenario ? product.final_price_scenario : product.status_price }}€</span>
              </div>
              <h4>*Il pagamento dovrà essere effettuato in contrassegno contanti direttamente al corriere.</h4>
            </div>
          </div>

          <div v-else-if="product.scenario && !scenarioIsAConfirmedScenario(product.scenario.sigla)">
            <h3>Opzione scelta</h3>
            <h4>{{ product.scenario.label }}</h4>
            <h4>{{ product.scenario.nome }}</h4>
            <p v-if="product.scenario.descrizione">{{ product.scenario.descrizione }}</p>
          </div>

          <div v-else-if="product.need_scenario">
            <h3>
              Seleziona un'opzione
            </h3>
            <div
              v-for="(scenario, index) in product.stato.scenari"
              :key="index"
              @click="openConfirmDialog(product, scenario)"
            >
              <v-card
                class="ghd-border-black mt-3"
              >
                <v-card-text>
                  {{ scenario.nome }}
                </v-card-text>
              </v-card>
            </div>
          </div>

          <div v-else-if="product.stato.id === 2 && product.testo_assistenza">
            <div>
              <span class="ghd-ITCAvant text-large text-black">IN GARANZIA </span>
            </div>
          </div>

          <div v-else-if="product.stato.id === 2 && !product.testo_assistenza">
            <div>
              <span class="ghd-ITCAvant text-large text-black">IN ATTESA DI VERIFICA </span>
            </div>
          </div>

        </v-card-text>

        <v-card-text v-if="product.testo_assistenza && !product.scenario">
          <div v-html="product.testo_assistenza"></div>
        </v-card-text>
      </v-card>
    </v-col>

    <dialog-dynamic
      v-if="confirmDialogVisibile"
      :data="{title: 'Confermare scelta?', 'subtitle': 'Ti informiamo che non è possibile modificare la scelta in seguito.'}"
      @turnoff="confirmDialogVisibile = false"
    >
      <template v-slot:action>
        <div style="flex: 1; margin: 5px">
          <div>
            <v-btn
              color="primary"
              block
              style="border: 2px solid white !important;"
              @click="confirmDialogVisibile = false"
            >
              Non confermo
            </v-btn>
          </div>
        </div>
        <div style="flex: 1; margin: 5px">
          <div>
            <v-btn
              color="primary"
              block
              style="border: 2px solid white !important;"
              @click="saveScenario(productChoosed, scenarioChoosed.id)"
            >
              Confermo
            </v-btn>
          </div>
        </div>
      </template>
    </dialog-dynamic>
  </v-row>
</template>

<script>
import {
  mdiLockOpenOutline,
  mdiStarOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import dayjs from 'dayjs'
import store from '@/store'
import DialogDynamic from '@/views/dialogs/dialogDynamic.vue'

export default {
  name: 'ColumnLeft',
  components: { DialogDynamic },

  props: {
    assistance: {
      required: true,
      type: [Object, Array],
    },
  },
  setup(props, { emit }) {
    const sidebarData = ref(null)
    const isInvoiceSendSidebarActive = ref(false)
    const confirmDialogVisibile = ref(false)

    const productChoosed = ref(null)
    const scenarioChoosed = ref(null)

    const openSidebar = product => {
      sidebarData.value = product
      isInvoiceSendSidebarActive.value = !isInvoiceSendSidebarActive.value
    }

    const openConfirmDialog = (product, scenario) => {
      productChoosed.value = product
      scenarioChoosed.value = scenario
      confirmDialogVisibile.value = true
    }

    const saveScenario = (prodotto, scenario) => {
      const sendData = {
        code: props.assistance.code,
        prodotti: {
          [prodotto.id]: {
            scenario_id: scenario,
            data_scelta_scenario: dayjs().unix(),
          },
        },
      }

      store.dispatch('assistance/updateAssistance', sendData).then(() => {
        emit('refetchdata')
        confirmDialogVisibile.value = false
      })
    }

    const scenarioIsAConfirmedScenario = scenario => scenario === 'CFPRV' || scenario === 'CFSRO'

    const getLabelForConfirmedScenario = scenario => (scenario === 'CFPRV' ? 'Preventivo confermato' : 'Sconto rottamazione confermato')



    return {
      icons: {
        mdiLockOpenOutline,
        mdiStarOutline,
      },
      openSidebar,
      sidebarData,
      isInvoiceSendSidebarActive,
      confirmDialogVisibile,
      productChoosed,
      scenarioChoosed,
      openConfirmDialog,
      saveScenario,
      scenarioIsAConfirmedScenario,
      getLabelForConfirmedScenario,
    }
  },
}
</script>

<style scoped>

</style>
